import React from 'react';
import { Box } from '@mui/material';

/** App mockup served as WebP with a PNG fallback (the originals were 25 MB of PNG). */
export function Mockup({ name, alt, sx, eager = false }) {
  return (
    <Box component="picture" sx={{ display: 'block', ...sx }}>
      <source srcSet={`/images/${name}.webp`} type="image/webp" />
      <Box
        component="img"
        src={`/images/${name}.png`}
        alt={alt}
        loading={eager ? 'eager' : 'lazy'}
        decoding="async"
        width={900}
        height={name === 'mockup-feed' ? 1188 : 1128}
        sx={{ width: '100%', height: 'auto', display: 'block' }}
      />
    </Box>
  );
}

export default Mockup;
